// test1147
(1147 && 0);
